export default __webpack_public_path__ + "static/ti_caravan_logo-f089a1ebf98c9a8fbdf0cfe37d2388af.svg";